import React from "react"
import styled from "styled-components"
import Breakpoints from "../shared/breakpoints"
import Grid from "../shared/grid"
import LinkComponent from "../shared/link"
import { T } from "../shared/typography.styles"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Container = styled.div`
  padding: 64px 0;
  background-color: var(--light-background);
  @media (min-width: ${Breakpoints.lg}) {
    padding: 96px 0;
  }
`

const StyledImg = styled(Img)`
  grid-column: 1 / -1;
  @media (min-width: ${Breakpoints.md}) {
    grid-column: 3 / -3;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 7 / -1;
  }
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 1 / -1;
  align-items: center;
  margin-top: 32px;
  @media (min-width: ${Breakpoints.md}) {
    margin-top: 48px;
    grid-column: 2 / -2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 6;
    grid-row: 1/-1;
    align-self: center;
    align-items: flex-start;
    margin-top: 0;
  }
`

const Title = styled.h2`
  ${T.sm.h2.bold}
  grid-column: 1 / -1;
  text-align: center;
  color: var(--slate);

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h2.bold}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h2.bold}
    text-align: left;
  }
`

const Description = styled.p`
  ${T.sm.body.regular}
  grid-column: 1 / -1;
  text-align: center;
  margin: 24px 0 32px;
  color: var(--body-text-grey);
  @media (min-width: ${Breakpoints.md}) {
    ${T.md.body.regular}
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.body.regular}
    text-align: left;
    margin: 24px 0 48px;
  }
`

const StyledLink = styled(LinkComponent)`
  width: 282px;
  @media (min-width: ${Breakpoints.md}) {
    width: max-content;
    padding: 16px 48px;
  }
`

export default function MappingSDKs() {
  const query = useStaticQuery(graphql`
    query {
      laptopImg: file(
        relativePath: {
          eq: "3_RESOURCES/Partner Program/01_desktop/mapping_sdks_desktop.png"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <Container>
      <Grid>
        <StyledImg
          imgStyle={{ objectFit: "contain" }}
          fluid={query.laptopImg.childImageSharp.fluid}
          alt="TODO: "
        />
        <ContentContainer>
          <Title>Mapping SDKs</Title>
          <Description>
            Our Mapping SDKs are built with flexibility in mind. We provide the
            core mapping components so that you can build accurate and
            feature-rich indoor mapping experiences.
          </Description>
          <StyledLink href="/mapping/sdks/">Explore our sdks</StyledLink>
        </ContentContainer>
      </Grid>
    </Container>
  )
}
